import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopalgharcab() {



    const cardData = {





keyword: "Mumbai to Palghar Cab",

headingDescription: "Shreesha Tours & Travels provides comfortable and reliable Mumbai to Palghar Cab Service for family trips, weekend getaways, business travel, corporate transportation, sightseeing tours, and local outstation journeys. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, and premium cab options for a safe and convenient travel experience from Mumbai to Palghar. With experienced drivers, clean and well-maintained vehicles, transparent pricing, doorstep pickup, flexible booking options, and 24/7 customer support, we ensure a smooth and hassle-free journey. Whether you are visiting Palghar for beaches, nature spots, temples, resorts, or nearby attractions, Shreesha Tours & Travels provides dependable cab booking services with complete comfort and convenience.",

topPlaces: [
  {
    title: "Kelva Beach Palghar",
    description: "Kelva Beach is one of Palghar's most popular coastal destinations, known for its long shoreline, peaceful atmosphere, sunset views, and relaxing weekend experience."
  },
  {
    title: "Shirgaon Beach Palghar",
    description: "Shirgaon Beach is a beautiful and less crowded beach destination near Palghar, famous for its clean surroundings, scenic views, and peaceful environment."
  },
  {
    title: "Shirgaon Fort",
    description: "Shirgaon Fort is a historic coastal fort near Palghar, offering beautiful sea views and a glimpse into the region's past. It is a popular place for history lovers."
  },
  {
    title: "Dahanu Beach",
    description: "Dahanu Beach is a scenic coastal attraction near Palghar known for peaceful surroundings, coconut plantations, and relaxing seaside views."
  },
  {
    title: "Bordi Beach",
    description: "Bordi Beach is famous for its calm shoreline, chikoo plantations, greenery, and peaceful atmosphere. It is a preferred destination for family vacations and weekend trips."
  },
  {
    title: "Vaitarna Dam",
    description: "Vaitarna Dam is a beautiful nature destination near Palghar surrounded by hills and greenery. It is ideal for photography, sightseeing, and peaceful getaways."
  },
  {
    title: "Tandulwadi Fort",
    description: "Tandulwadi Fort is a popular trekking destination near Palghar, offering panoramic views of villages, forests, and surrounding landscapes."
  },
  {
    title: "Jai Vilas Palace Jawhar",
    description: "Jai Vilas Palace in Jawhar is a heritage attraction known for royal architecture, tribal culture, and beautiful surroundings of the hill region."
  },
  {
    title: "Dabhosa Waterfall",
    description: "Dabhosa Waterfall near Jawhar is a scenic natural attraction surrounded by forests and hills. It is popular for adventure activities and nature trips."
  },
  {
    title: "Jawhar Hill Station",
    description: "Jawhar is a beautiful tribal hill station near Palghar known for waterfalls, viewpoints, Warli art, and peaceful natural surroundings."
  }
],



"services": [
  {
    "name": "Mumbai to Palghar Cab",
    "description": "Book Mumbai to Palghar Cab for safe, comfortable, and reliable travel with professional chauffeurs and well-maintained AC vehicles. Enjoy a smooth journey from Mumbai to Palghar with Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cab options suitable for family trips, business travel, weekend getaways, and local sightseeing."
  },
  {
    "name": "Mumbai to Palghar Taxi",
    "description": "Choose Mumbai to Palghar Taxi for affordable and convenient transportation with experienced drivers and comfortable vehicles. Get doorstep pickup, clean AC cars, transparent pricing, and reliable taxi service for personal, family, and tourist travel."
  },
  {
    "name": "Mumbai to Palghar Cab Service",
    "description": "Book Mumbai to Palghar Cab Service for dependable outstation and local travel solutions with trained chauffeurs and premium vehicles. Our cab services are ideal for family tours, corporate trips, weekend travel, and comfortable journeys from Mumbai."
  },
  {
    "name": "Mumbai to Palghar Taxi Service",
    "description": "Hire Mumbai to Palghar Taxi Service for smooth and hassle-free travel with professional drivers and well-maintained cars. Enjoy flexible booking options, comfortable seating, affordable fares, and reliable taxi facilities for your Palghar journey."
  },
  {
    "name": "Mumbai to Palghar Cab Booking",
    "description": "Complete Mumbai to Palghar Cab Booking easily with quick confirmation and multiple vehicle options. Select Sedan, SUV, Ertiga, Innova, or premium cars according to your group size and enjoy a comfortable travel experience."
  },
  {
    "name": "Mumbai to Palghar Car Rental",
    "description": "Choose Mumbai to Palghar Car Rental for chauffeur-driven vehicles designed for comfortable short-distance and outstation travel. Enjoy spacious cars, professional drivers, flexible rental plans, and affordable packages for family and business requirements."
  },
  {
    "name": "Mumbai to Palghar One Way Cab",
    "description": "Book Mumbai to Palghar One Way Cab for convenient drop taxi service without return fare charges. Travel comfortably with skilled drivers, clean vehicles, and flexible pickup locations from Mumbai."
  },
  {
    "name": "Mumbai to Palghar Round Trip Taxi",
    "description": "Reserve Mumbai to Palghar Round Trip Taxi for comfortable return journeys with flexible timings and reliable vehicles. Ideal for family visits, sightseeing, weekend trips, and extended stays in Palghar."
  },
  {
    "name": "Mumbai Airport to Palghar Cab",
    "description": "Book Mumbai Airport to Palghar Cab for smooth airport transfer services with timely pickup and direct travel options. Enjoy luggage-friendly vehicles, professional chauffeurs, and comfortable transportation from Mumbai Airport to Palghar."
  },
  {
    "name": "Mumbai to Palghar Outstation Cab",
    "description": "Choose Mumbai to Palghar Outstation Cab for safe and reliable long-distance transportation with premium vehicles and experienced chauffeurs. Perfect for personal travel, corporate journeys, family trips, and weekend destinations."
  },
  {
    "name": "Mumbai to Palghar Private Taxi",
    "description": "Hire Mumbai to Palghar Private Taxi for personalized travel with a dedicated vehicle and professional chauffeur. Enjoy privacy, flexible routes, comfortable seating, and a peaceful journey for business or personal transportation."
  },
  {
    "name": "Mumbai to Palghar Tourist Cab",
    "description": "Book Mumbai to Palghar Tourist Cab for comfortable sightseeing and holiday travel. Explore Palghar attractions, beaches, forts, and nearby destinations with professional drivers and flexible tour cab options."
  },
  {
    "name": "Mumbai to Palghar Innova Cab",
    "description": "Choose Mumbai to Palghar Innova Cab for spacious and comfortable travel with premium seating and extra luggage space. Perfect for families and groups looking for a relaxing journey from Mumbai to Palghar."
  },
  {
    "name": "Best Mumbai Palghar Cab Service",
    "description": "Choose the Best Mumbai Palghar Cab Service for safe, comfortable, and affordable travel. Enjoy premium vehicles, trained chauffeurs, flexible booking options, and reliable cab packages for family trips, corporate travel, sightseeing, and weekend journeys between Mumbai and Palghar."
  }
],
"tableData": [
  ["Mumbai to Palghar Cab", "Mumbai to Palghar Taxi"],
  ["Mumbai to Palghar Cab Service", "Mumbai to Palghar Taxi Service"],
  ["Mumbai to Palghar Cab Booking", "Mumbai to Palghar Car Rental"],
  ["Mumbai to Palghar One Way Cab", "Mumbai to Palghar Round Trip Taxi"],
  ["Mumbai Airport to Palghar Cab", "Mumbai to Palghar Outstation Cab"],
  ["Mumbai to Palghar Private Taxi", "Mumbai to Palghar Tourist Cab"],
  ["Mumbai to Palghar Innova Cab", "Best Mumbai Palghar Cab Service"]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Palghar Cab Service",
    WhyChoosedescription: "Shreesha Travels offers comfortable Mumbai to Palghar cab services for families, business travellers, tourists, and local commuters. Enjoy a smooth journey with professional chauffeurs, clean vehicles, and flexible booking options."
  },
  {
    WhyChooseheading: "Convenient Travel from Mumbai to Palghar",
    WhyChoosedescription: "Travel easily from Mumbai to Palghar for weekend trips, industrial visits, family functions, beach outings, and personal requirements with a private chauffeur-driven cab."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles Available",
    WhyChoosedescription: "Select from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other vehicles according to your passenger count and comfort needs."
  },
  {
    WhyChooseheading: "Perfect for Family Trips & Nearby Getaways",
    WhyChoosedescription: "Our Mumbai to Palghar taxis are suitable for family visits, weekend holidays, corporate travel, sightseeing, beach trips, and customized Maharashtra travel plans."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Booking",
    WhyChoosedescription: "Choose a one-way cab for direct travel to Palghar or book a round-trip package with flexible return timing, waiting options, and customized travel arrangements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Maharashtra Routes",
    WhyChoosedescription: "Our professional chauffeurs have good knowledge of Mumbai-Palghar routes and nearby destinations, ensuring safe driving, timely service, and comfortable travel."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Cars",
    WhyChoosedescription: "Every vehicle is regularly serviced, sanitized, air-conditioned, and inspected before trips to provide a reliable and pleasant travel experience."
  },
  {
    WhyChooseheading: "Book Mumbai to Palghar Cab with Shreesha Travels",
    WhyChoosedescription: "Get transparent pricing, quick booking support, comfortable vehicles, and dependable cab services for your journey from Mumbai to Palghar."
  }
]

};

const faqData = [
  {
    question: "Can I book a Mumbai to Palghar cab for a family trip?",
    answer: "Yes, we provide comfortable Mumbai to Palghar cabs for family visits, sightseeing, weekend trips, and personal travel."
  },
  {
    question: "Is Mumbai to Palghar one-way cab service available?",
    answer: "Yes, one-way cab booking is available for passengers who need direct transportation from Mumbai to Palghar."
  },
  {
    question: "Which vehicles are available for Mumbai to Palghar travel?",
    answer: "We offer Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "Can I book a round-trip taxi from Mumbai to Palghar?",
    answer: "Yes, round-trip cab packages are available with flexible return schedules and customized travel plans."
  },
  {
    question: "Is Palghar suitable for weekend travel from Mumbai?",
    answer: "Yes, Palghar is a popular nearby destination for weekend getaways, nature trips, beaches, and peaceful family outings."
  },
  {
    question: "Can I customize my Mumbai to Palghar travel route?",
    answer: "Yes, you can customize your journey with sightseeing stops, nearby attractions, and preferred travel schedules."
  },
  {
    question: "Do you provide corporate cab services from Mumbai to Palghar?",
    answer: "Yes, our services are suitable for industrial visits, office travel, business meetings, and corporate requirements."
  },
  {
    question: "How is the Mumbai to Palghar cab fare calculated?",
    answer: "The fare depends on vehicle type, travel distance, trip duration, route, waiting time, and selected service package."
  },
  {
    question: "Are same-day return trips available from Mumbai?",
    answer: "Yes, same-day return options can be arranged according to your travel schedule and requirements."
  },
  {
    question: "How can I book Mumbai to Palghar Cab with Shreesha Travels?",
    answer: "Share your pickup location, travel date, passenger details, preferred vehicle, and trip requirements to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Shah",
    feedback: "The Mumbai to Palghar cab service was comfortable and reliable. The driver was punctual, the car was clean, and the journey was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback: "We had a great experience with Shreesha Travels. The booking process was easy, and the comfortable vehicle made our family trip enjoyable.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Palghar Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-palghar-cab.webp",
  "description":
    "Book Mumbai to Palghar Cab with Shreesha Tours & Travels for safe, comfortable, and affordable local and outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for family trips, business travel, weekend getaways, airport transfers, and one-way or round-trip journeys from Mumbai to Palghar with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-palghar-cab"
  }
};




    return (
        <div>

<Helmet>
  <title>Mumbai to Palghar Cab | One Way & Round Trip Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Palghar Cab with Shreesha Travels for reliable local and outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for Palghar travel, weekend trips, family journeys, airport transfers, and one-way or round-trip rides with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Palghar Cab, Mumbai to Palghar Taxi, Mumbai to Palghar Cab Service, Mumbai to Palghar Taxi Service, Mumbai to Palghar Cab Booking, Mumbai to Palghar Car Rental, Mumbai to Palghar One Way Cab, Mumbai to Palghar Round Trip Taxi, Mumbai Airport to Palghar Cab, Mumbai Palghar Outstation Taxi, Mumbai Palghar Car Hire, Palghar Taxi Service from Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/74.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitopalgharcab;